import { AxiosError } from 'axios';
import { NetworkErrors } from './axios-interceptors/axios-types';

export const UserHasCanceledImport = 'UserHasCanceledImport';
export const ImportTherapyDataTimeError = 'Error_ImportTherapyDataTimeError';
export const CouldNotSynchronizeDeviceTime = 'CouldNotSynchronizeDeviceTime';
export const PhoneTimeDiffersWithUtc = 'PhoneTimeDiffersWithUtc';

export enum SentryErrorMessages {
  AuthError = 'Authentication error',
  NetworkError = 'Network Error',
  SmthWentWrong = 'Unidentified error',
}

export function isTimeError(e: Error) {
  return e.message.includes(ImportTherapyDataTimeError);
}
export function isUploadCanceledError(e: Error) {
  return e.message.includes(UserHasCanceledImport);
}
export class UploadCanceledError extends Error {
  constructor() {
    super(UserHasCanceledImport);
  }
}

export function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

export function isNetworkError(e: any) {
  if (isAxiosError(e)) {
    const lowercaseMessage = e?.message?.toLowerCase();
    return lowercaseMessage?.includes('Network Error'.toLowerCase()) || e.code === 'ECONNABORTED';
  }
  if (e.message === SentryErrorMessages.NetworkError) return true;
  if (e.message === NetworkErrors.NoInternet) return true;
  if (e.message === NetworkErrors.Maintenance) return true;

  return false;
}
